import KeyMirror from 'keymirror';

const TopicType = KeyMirror({
	GET_LIST_TOPIC: null,
	GET_LIST_TOPIC_PAGING: null,
	GET_NORMAL_TOPIC: null,
	CREATE_TOPIC: null,
	UPDATE_TOPIC: null,
	HIDE_TOPIC: null,
	DELETE_TOPIC: null,
	PIN_TOPIC: null,
});

export default TopicType;
